import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { questionnaireReducerAtom } from "../state/questionnaireReducerAtom";
import { selectAtom } from "jotai/utils";
import type { Section } from "../types";

/**
 * Hook to retrieve a specific section by its ID.
 * Uses a Jotai selector to only subscribe to changes for this specific section.
 * @param sectionId - The ID of the section to retrieve
 * @returns The section object if found, or undefined
 */
export const useSectionById = (
  sectionId: string | undefined,
): Section | undefined => {
  const sectionAtom = useMemo(() => {
    if (!sectionId) {
      return selectAtom(questionnaireReducerAtom, () => undefined);
    }

    return selectAtom(questionnaireReducerAtom, state =>
      state.sections.find(s => s.id === sectionId),
    );
  }, [sectionId]);

  return useAtomValue(sectionAtom);
};
